import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import {isEmpty} from '../../../helpers/utils'
import Question from './Question'

const useStyles = makeStyles(sectionStyles)
 
export default function Section ({assessment, sections, section, sectionIndex, context}) {

  const classes = useStyles()
  const {translate} = context

  const questions = section.questions.map(q => ({...q, sectionId: section.id}))

  const title = isEmpty(section.title) ? `${translate('section')} ${sectionIndex + 1}` : section.title

  const instructions = section && (isEmpty(section.instructions) ? false: section.instructions)
  const defaultInstructions = translate('default-section-instructions')
  const hasDefaultInstructions = defaultInstructions != 'default-section-instructions'
  const hasInstructions = instructions != false || hasDefaultInstructions

  return (
    <React.Fragment>
      <Box className={classes.root}>
        <Box className={classes.header}>
          <Box className={classes.title}>{title}</Box>
        </Box>
        {hasInstructions && (
          <Box className={classes.instructionsWrapper}>
            <Box className={classes.label}>{translate('instructions')}</Box>
            {instructions && <div className={classes.instructions} dangerouslySetInnerHTML={{__html: instructions}} />}
            {!instructions && <Box className={classes.instructions}>{defaultInstructions}</Box>}
          </Box>)}
      </Box>
      {questions.map((question, questionIndex) => (
        <Box key={question.id} className={classes.question}>
          <Question {...{assessment, context, section, sections, question, questionIndex}} />
        </Box>
      ))}
    </React.Fragment>
  )
}

function sectionStyles(theme) {

  const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }

  return {
    root: {
      flexGrow: 1,
      display: 'flex',
      flexDirection: 'column',
      color: '#525b6c',
    },
    header: {
      display: 'flex',
      fontSize: '12pt',
      padding: '10px 20px',
      backgroundColor: '#2c75bd',
      border: 'solid 1px #2c75bd',
      borderBottom: 0,
      color: '#fff'
    },
    label: {
      marginBottom: 10
    },
    instructionsWrapper: {
      flexGrow: 1,
      overflowY: 'auto',
      padding: 30,
      border: 'solid 1px #d0d5d8',
    },
    instructions: {
      flexGrow: 1,
    },
  }
}


